import ExpressRoutesPopover from './express-routes-popover.vue'

ExpressRoutesPopover.install = (app) => {
    app.component(ExpressRoutesPopover.name, ExpressRoutesPopover)
}

export default ExpressRoutesPopover
